import { clsx } from "@frend-digital/ui";
import type React from "react";
import type { ComponentProps } from "react";
import styles from "./Skeleton.module.css";

export interface SkeletonProps extends ComponentProps<"div"> {
	fit?: boolean;
	children?: React.ReactNode;
	width?: string | number;
	height?: string | number;
	scaleY?: boolean;
	scaleX?: boolean;
	stroke1?: boolean;
}

export const Skeleton = ({
	fit,
	className,
	children,
	width = "100%",
	height,
	scaleY,
	scaleX,
	stroke1,
	...rest
}: SkeletonProps) => {
	return (
		<div
			aria-hidden
			className={clsx(
				styles.root,
				className,
				fit && styles.fit,
				scaleY && styles.scaleY,
				scaleX && styles.scaleX,
				stroke1 && styles.stroke1,
			)}
			inert
			style={
				{
					"--width": width,
					"--height": height,
				} as React.CSSProperties
			}
			{...rest}
		>
			{children}
		</div>
	);
};
